<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-card>
        <tt-button-goto [ttText]="'create_new_productunit'" (ttClick)="goToFunc('productunit')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListProductUnits"></tt-list>
</tt-page>
